<template>
  <div class="cmodal h-card shadow">
    <div class="card-header">
      <h5 class="modal-title">{{ title }}</h5>
      <button type="button" @click="closeCmodal" class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <label>Комментарий</label>
        <textarea class="form-control" v-model="commentTenant"></textarea>
        <div class="hint">Виден только Вам.</div>
      </div>
      <div class="mb-3">
        <label>Комментарий для администрации</label>
        <textarea class="form-control" v-model="comment"></textarea>
        <div class="hint">Виден Вам и администрации сайта.</div>
      </div>
    </div>
    <div class="card-footer">
      <button class="ok-btn me-1" @click="save">Сохранить</button>
      <button class="close-btn" @click="closeCmodal">Закрыть</button>
    </div>
  </div>
</template>
<script>
import {popModal} from "jenesius-vue-modal";

export default {
  name: 'CommentModal',
  props: {
    data: Object,
  },
  data() {
    return {
      'comment':'',
      'commentTenant':''
    }
  },
  created() {
    this.comment = this.data.comment;
    this.commentTenant = this.data.commentTenant;
  },
  computed: {
    getId() {
      return this.data.id
    },
    title() {
      return 'Бронь на ' + this.data.hour + ':' + this.data.minuteView;
    }
  },
  methods:{
    closeCmodal(){
      popModal();
    },
    save(){
      let sendData = {
        cabinetId:this.data.cabinetId,
        officeId:this.data.officeId,
        date:this.data.date,
        hour:this.data.hour,
        minuteView:this.data.minuteView,
        comment:this.comment,
        commentTenant:this.commentTenant,
        id:this.data.id,
      };
      this.$emitter.emit('saveComments',sendData)
      this.closeCmodal()
    }
  }
}
</script>
<style scoped>
.cmodal {
  width: 460px;
}
.cmodal textarea{
  border-radius: .3em;
}
.cmodal .card-header{
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
.cmodal textarea{
  height: 100px;
  font-size: .9rem;
}
.cmodal label{
  margin-bottom: 0.1rem;
  font-size: 0.85rem;
  color: #ad8b57;
}
.cmodal .hint{
  margin-top: 0.1rem;
  font-size: .75em;
  color:#999;
}
.cmodal  .card-body {
  overflow: auto;
  height: 400px;
  max-height: 95vh;
}
</style>